const translations = {
    deleteAll: 'Delete All'
};

export default translations;
